import { Repetition } from "src/app/kuba/follow-ups/models/activities";

export class managetemperaturecontrol {
     Id: number;
     FoodSafetyId: number;
     ControlId:number;
     Repetition: Repetition[];
     EmailNotificationPastDeadline: number;
     CreatedBy: number;
}